import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm, NoValidateForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { applySMSRequest, machineInstallManualPay } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppSelector } from "../../redux/store/storehooks";
import { InfoText } from "./styles";

export const ApplySMSRequestDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(NoValidateForm) as any
    const myStore = useAppSelector((state) => state)
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
        setIsLoading(false);
    },[])

    const onSubmitForm = (e:any) => {
        e.preventDefault();
  
        setIsSubmiting(true)

        applySMSRequest(
            Number(payLoad.labId),
            myStore.auth.userId || 0,
            Number(values.amount),
            values.description ? values.description : ""
        ).then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ثبت شد",undefined,5000)
            onCancel();
            setIsSubmiting(false)
        })
        .catch((error) => {
          console.log(error);
          setIsSubmiting(false)
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}
                {isLoading === false && (

                    <FormContainer title="اعمال شارژ پیامک" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                        
                        <Row>
                            <InfoText>مبلغ باقیمانده: {payLoad.int_ReminderAmount ? payLoad.int_ReminderAmount : 0}</InfoText>
                        </Row>

                        <Row>
                            <InfoText>تعداد باقیمانده: {payLoad.int_ReminderQuantity ? payLoad.int_ReminderQuantity : 0}</InfoText>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="amount"
                                    placeholder="مبلغ"
                                    value={values.amount || 0}
                                    onChange={handleChange}
                                />
                                <ValidationType type="amount" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomTextArea
                                    name="description"
                                    placeholder="توضیحات"
                                    value={values.description || ""}
                                    onChange={handleChange}
                                />
                                <ValidationType type="description" />
                            </Col>
                        </Row>

                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}